import { Link } from 'react-router-dom'
import { FileText } from 'lucide-react'
import { Badge } from '@/components/ui'
import type { WorkflowRunNode } from '@/types'

interface Props {
  node: Pick<WorkflowRunNode, 'promptId' | 'promptName' | 'promptAvailable'>
  projectId: string
}

export function NodePromptLink({ node, projectId }: Props) {
  if (!node.promptId || !node.promptName) return null

  if (!node.promptAvailable) {
    return (
      <Badge
        variant="outline"
        className="gap-1 text-xs text-muted-foreground"
        title="This prompt was deleted or is no longer available"
        data-testid="node-prompt-unavailable"
      >
        <FileText className="h-3 w-3" aria-hidden="true" />
        Prompt: {node.promptName} (unavailable)
      </Badge>
    )
  }

  return (
    <Link
      to={`/projects/${projectId}/workflows/prompts/${node.promptId}`}
      className="inline-flex"
      aria-label={`Open prompt ${node.promptName}`}
      data-testid="node-prompt-link"
    >
      <Badge variant="outline" className="gap-1 text-xs hover:bg-muted">
        <FileText className="h-3 w-3" aria-hidden="true" />
        Prompt: {node.promptName}
      </Badge>
    </Link>
  )
}
